import React, { useState, useEffect, useRef } from 'react';
import "../css/SecondaryImageSlideshow.css";
import { RiSingleQuotesL } from "react-icons/ri";
import * as imagesdata from '../imagesdata'
import { useInView } from 'react-intersection-observer';

const SecondaryImageSlideshow = () => {

    const slides = [
        {
            id: 1,
            img: imagesdata.SecImageSliderModern,
            headline: 'Vizyon',
            description: 'Akıllı teknolojilerle geleceğin şehirlerini inşa ediyoruz. Verimli trafik akışı ve dengeli geçiş yönetimiyle, hem araçlar hem de yayalar için daha adil bir deneyim sunuyoruz.'
        },
        {
            id: 2,
            img: imagesdata.SecImageSliderNature,
            headline: 'Misyon',
            description: 'Her araca ve yayaya hak ettiği önceliği tanıyan, çevreci ve sürdürülebilir trafik çözümleri geliştirmek için çalışıyoruz. Teknolojiyi insan odaklı bir yaklaşımla birleştiriyoruz.'
        },
        {
            id: 3,
            img: imagesdata.SecImageSliderComfort,
            headline: 'Değerler',
            description: 'Adalet, verimlilik ve yenilikçilik... Trafikte her birey için adil bir düzen kurarken, akıllı sistemlerle şehirlerin akışını kolaylaştırmayı hedefliyoruz.'
        }
    ];

    const [currentIndex, setCurrentIndex] = useState(null);
    const [isIntervalActive, setIsIntervalActive] = useState(false);

    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });
    const intervalRef = useRef(null);
    const interval = 10000;
    const activeDelay = 0.76;

    const headerRefs = useRef([]);
    const descriptionRefs = useRef([]);
    const quoteIconRefs = useRef([]);

    const startX = useRef(0); // Touch veya mouse başlangıç pozisyonu
    const threshold = 50;

    const resetClasses = () => {
        headerRefs.current.forEach((header) => header.classList.remove("active"));
        descriptionRefs.current.forEach((description) => description.classList.remove("active"));
        quoteIconRefs.current.forEach((quoteIcon) => quoteIcon.classList.remove("active"));
    };

    const transitionDelay = (items, isHeader) => {
        let seconds = isHeader ? 0.015 : 0.007;
        items.forEach((item, index) => {
            const children = Array.from(item.childNodes);
            children.forEach((child, count) => {
                const delay = (count + 1) * seconds + (item.parentNode.classList.contains('active') ? activeDelay : 0);
                if (child.firstElementChild) {
                    child.firstElementChild.style.transitionDelay = `${delay}s`;
                }
            });
        });
    };

    const nextSlide = () => {
        resetClasses();
        setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
    };

    const nextMouseSlide = () => {
        handleControlClick((currentIndex + 1) % slides.length);
    };

    const prevMouseSlide = () => {
        handleControlClick((currentIndex - 1 + slides.length) % slides.length);
    };

    const handleControlClick = (index) => {
        resetClasses();
        clearInterval(intervalRef.current);
        setCurrentIndex(index);
        const newIntervalId = setInterval(nextSlide, interval);
        intervalRef.current = newIntervalId
    };

    const handleTouchStart = (e) => {
        startX.current = e.touches ? e.touches[0].clientX : e.clientX;
    };

    const handleTouchEnd = (e) => {
        const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        const deltaX = endX - startX.current;

        if (Math.abs(deltaX) > threshold) {
            if (deltaX > 0) {
                prevMouseSlide(); // Sola kaydırıldı
            } else {
                nextMouseSlide(); // Sağa kaydırıldı
            }
        }
    };

    const handleMouseDown = (e) => {
        startX.current = e.clientX;
    };

    const handleMouseUp = (e) => {
        const deltaX = e.clientX - startX.current;
        if (Math.abs(deltaX) > threshold) {
            if (deltaX > 0) {
                prevMouseSlide(); // Sola kaydırıldı
            } else {
                nextMouseSlide(); // Sağa kaydırıldı
            }
        }
    };


    const startInterval = () => {
        if (!intervalRef.current) {
            const newIntervalId = setInterval(() => {
                nextSlide();
            }, interval);
            intervalRef.current = newIntervalId
        }
    };

    const stopInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            startInterval(); // Sayfa görünürse interval'i başlat
        } else {
            stopInterval(); // Sayfa gizlenirse interval'i durdur
        }
    };

    useEffect(() => {
        if (inView && currentIndex === null) {
            // currentIndex başlangıçta null olduğunda, görünürlük sağlanırsa 0 yap.
            setCurrentIndex(0);
        }

        // Eğer öğe görünürse ve currentIndex null değilse, interval başlat.
        if (inView && currentIndex !== null) {
            startInterval();
        } else {
            stopInterval();
        }

    }, [inView, currentIndex]);

    useEffect(() => {

        // Visibility değişim olayını dinle
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup: Sayfa unmount olduğunda interval'i ve event listener'ı temizle
        return () => {
            stopInterval();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [inView]);

    useEffect(() => {
        transitionDelay(headerRefs.current, true);
        transitionDelay(descriptionRefs.current, false);
        quoteIconRefs.current.forEach((icon) => {
            const delay = icon.parentNode.classList.contains('active') ? activeDelay : 0;
            icon.style.transitionDelay = `${delay}s`;  // Gecikme süresi
        });
    }, [currentIndex]);

    return (
        <div ref={ref} className="secondary-image-slider-body"
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            <div className="secondary-image-slider-content-width">
                <div className="secondary-image-slider-slideshow">
                    <div className="secondary-image-slider-slideshow-items">

                        {slides.map((slide, index) => (
                            <div
                                key={index}
                                className={`secondary-image-slider-item ${currentIndex === index ? 'active' : ''}`}
                            >
                                <div className='secondary-image-quote-icon-header' ref={(el) => (quoteIconRefs.current[index] = el)}>
                                    <div className='secondary-image-quote-left-icon'>
                                        <RiSingleQuotesL size={60} color='white' />
                                    </div>
                                    <div className='secondary-image-quote-right-icon'>
                                        <RiSingleQuotesL size={60} color='white' />
                                    </div>
                                </div>
                                <div className="secondary-image-slider-item-image-container">
                                    <img
                                        className="secondary-image-slider-item-image"
                                        src={slide.img}
                                        alt={slide.headline}
                                    />
                                </div>
                                <div
                                    className="secondary-image-slider-item-header"
                                    ref={(el) => (headerRefs.current[index] = el)}
                                >
                                    {slide.headline.split("").map((char, charIndex) => (
                                        <span
                                            key={charIndex}
                                            className="secondary-image-slider-vertical-part"
                                        >
                                            <b>{char}</b>
                                        </span>
                                    ))}
                                </div>
                                <div
                                    className="secondary-image-slider-item-description"
                                    ref={(el) => (descriptionRefs.current[index] = el)}
                                >
                                    {slide.description.split(" ").map((word, wordIndex) => (
                                        <span
                                            key={wordIndex}
                                            className="secondary-image-slider-vertical-part"
                                            style={{ marginRight: "5px" }}
                                        >
                                            <b>{word}</b>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="secondary-image-slider-controls">
                        <ul>
                            {slides.map((_, index) => (
                                <li
                                    key={index}
                                    className={`secondary-image-slider-control ${currentIndex === index ? "active" : ""}`}
                                    onClick={() => handleControlClick(index)}
                                ></li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecondaryImageSlideshow;
